module.exports = __webpack_public_path__ + "static/media/main idea.ea87c2bf.mp3";